import APIService from '../api.service';

export const List = (params) => {
    return APIService.get(`/v01/bills`, {
        params: {
            ...params
        },
    });
};

export const Create = (body, config = {}) => {
    return APIService.post(`/v01/bills`, body, config);
};

export const Put = (id, body, config = {}) => {
    return APIService.put(`/v01/bills/${id}`, body, config);
};

export const Detail = (id) => {
    return APIService.get(`/v01/bills/${id}`);
};

const BillService = {
    List,
    Create,
    Put,
    Detail,
};
export default BillService;
